module.exports = __webpack_public_path__ + "img/10649907_827527410623048_1276520106862167037_n.858df859.jpg";